import { updateTeamRole } from './types';

export function requestUpdateTeamRole(userId, role) {
  return {
    type: updateTeamRole.request,
    userId,
    role,
  };
}

export function requestUpdateTeamRoleSuccess(userId, roles) {
  return {
    type: updateTeamRole.success,
    userId,
    roles,
  };
}

export function requestUpdateTeamRoleFailure(userId, error) {
  return {
    type: updateTeamRole.failure,
    userId,
    error,
  };
}
